import OnlineHelp from './OnlineHelp';

interface PageHeaderProps {
  title: string;
  onlineHelpTopic?: string;
  show?: boolean;
}

export default function PageHeader(props: PageHeaderProps): JSX.Element | null {
  if (props.show !== undefined && !props.show) {
    return null;
  }
  return (
    <div className="w-full bg-white p-3.5">
      <h1 className="text-base color-[#494949]">
        {props.title}
        {props.onlineHelpTopic && <OnlineHelp topic={props.onlineHelpTopic} />}
      </h1>
    </div>
  );
}
